import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import data from '../data/stdominicana';

const Header = () => {
    return (
        <Container>
            <Navbar className="gap-3 px-4 mt-4" bg="transparent" expand="md">
                <Navbar.Brand href="/">
                    <img
                        src={data.logo}
                        className="align-top brand-logo"
                        alt={data.title}
                    />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse className="justify-content-end" id="basic-navbar-nav">
                    <Nav className="flex-grow-1 justify-content-end align-items-center">
                        <Nav.Item className='mx-md-4'>
                            <Nav.Link href="/">Inicio</Nav.Link>
                        </Nav.Item>
                        <Nav.Item className='mx-md-4'>
                            <Nav.Link href="/nuestra-experiencia">Nuestra Experiencia</Nav.Link>
                        </Nav.Item>
                        <Nav.Item className='mx-md-4'>
                            <Nav.Link href="/trabajos-realizados">Trabajos Realizados</Nav.Link>
                        </Nav.Item>
                       <Nav.Item className="btn btn-secondary">
                            <Nav.Link href="mailto:info@stdominicana.com" className="btn btn-secondary border-0 px-3 text-white">Contáctenos</Nav.Link>
                       </Nav.Item>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </Container>
    );
};

export default Header;
